import {ROUTE_KEY} from '@lookiero/promocodes-front';
import {Path} from '../../../modules/routing/routes.definition';

const getRoute = (route: string): string => {
  /**
   * This ROUTES object inside a function is a workaround to avoid undefined values because of circular dependencies
   * Refer to this JIRA for more details on this: https://lookiero.atlassian.net/browse/LK-26564
   */
  const ROUTES: Partial<Record<ROUTE_KEY, string>> = {
    [ROUTE_KEY.SHOP]: Path.LOOK_IN_HOME,
  };
  return ROUTES[route as ROUTE_KEY] || '';
};

export {getRoute};
